// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"tHa9u","richHeading":"QORFo","customHeading":"_8--6j","richBody":"_9Mng9","richLegal":"HK5tv"};